module.exports = __webpack_public_path__ + "img/ЗВ-13(КВ)-006.0d619659.png";